export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true, "sameSite": "lax"},
 clients: {"default": {"httpEndpoint": "/graphql-insurance-product-review", "tokenName": "apollo-token", "authType": "Bearer", "authHeader": "Authorization", "tokenStorage": "cookie", "defaultOptions": {"query": {"errorPolicy": "all"}}}}
}